import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { ContextProvider } from "../Context/SharedStateContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from 'react-router-dom';
import Header from "../../Epic-X/Components/Header";
import Footer from "../../Epic-X/Components/Footer";

const ChatPrice = () => {
  const navigate = useNavigate();
  const { setPlanSelected, setPlanTypeSelected } = useContext(ContextProvider);
  const [isYearly, setIsYearly] = useState(false);
  const [currentPlan, setCurrentPlan] = useState(null);
  const localURL = localStorage.getItem("shopURL");

  const headers = {
    "Content-Type": "application/json",
    "x-shop-url": localURL,
  };

  const togglePricing = () => {
    setIsYearly(!isYearly);
  };

  const fetchClientinfo = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/clientinfo`, {
        params: {
          storeUrl: localURL,
          product: 'Chat'
        },
      });
      if (response.data.plan_info && response.data.plan_info.plan_name) {
        setCurrentPlan(response.data.plan_info.plan_name.toLowerCase());
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
    fetchClientinfo();
  }, []);

  const pricingPlans = [
    {
      title: "Free",
      description: "Best for personal use",
      monthlyPrice: "$0",
      yearlyPrice: "$0",
      features: [
        "Up to 10 Handled Conversations",
        "Live chat",
        "Ticketing",
        "AI Chat Bot"
      ],
      planName: "free"
    },
    {
      title: "Growth",
      description: "Best for personal use",
      monthlyPrice: "$29",
      yearlyPrice: "$299",
      features: [
        "Up to 500 Handled Conversations",
        "Basic analytics",
        "Live visitors list",
        "Operating hours",
        "Live chat support (24/5)"
      ],
      planName: "growth"
    },
    {
      title: "Professional",
      description: "Best for personal use",
      monthlyPrice: "$59",
      yearlyPrice: "$659",
      features: [
        "Up to 1000 Handled Conversations",
        "No Epic-x branding (add-on)"
      ],
      planName: "professional"
    },
    {
      title: "Premium",
      description: "Best for personal use",
      monthlyPrice: "$499",
      yearlyPrice: "$5499",
      features: [
        "Custom Conversations Unlimited",
        "Dedicated Success Manager",
        "Training sessions"
      ],
      planName: "premium"
    }
  ];

  async function handleGetStarted(plans) {
    try {
      return;
      const response = await axios.post(
        `${process.env.REACT_APP_CHAT_BACKEND_URL}/api/create-subscription`,
        { planName: plans },
        { headers }
      );
      if (response.data.confirmationUrl) {
        window.location.href = response.data.confirmationUrl;
      } else {
        const product = `Chat`;
        const pricingType = isYearly ? "year" : "month";
        navigate(
          `/Register?product=${product}&plan=${plans}&type=${pricingType}`
        );
      }
    } catch (error) {
      console.error("Error creating subscription:", error);
    }
  }

  return (
    <div>
      {/* Header Start */}
      <Header />
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Pricing</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">Pricing</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* Pricing Section Start */}
      <div className="container-fluid py-5">
        <div className="epic-x-pricing-container">
          <div className="text-center">
            <h2 className="epic-x-heading">Streamline your teamwork. Start free.</h2>
            <p className="epic-x-subheading">Choose the perfect plan for your business needs</p>
          </div>
          {/*<div className="epic-x-toggle-container">
            <span className="epic-x-toggle-label">Pay Monthly</span>
            <label className="epic-x-switch">
              <input type="checkbox" id="toggle" checked={isYearly} onChange={togglePricing} />
              <span className="epic-x-slider epic-x-round"></span>
            </label>
            <span className="epic-x-toggle-label">Pay Yearly</span>
          </div>*/}
          <div className="epic-x-pricing-plans">
            {pricingPlans.map((plan, index) => (
              <div
                key={index}
                className={`epic-x-plan ${currentPlan === plan.planName ? 'epic-x-plan-active' : ''}`}
              >
                {currentPlan === plan.planName && (
                  <div className="epic-x-current-plan-badge">Current Plan</div>
                )}
                <h3 className="epic-x-plan-title">{plan.title}</h3>
                <p className="epic-x-plan-description">{plan.description}</p>
                <p className="epic-x-price">
                  {isYearly ? plan.yearlyPrice : plan.monthlyPrice}{" "}
                  <span className="epic-x-price-duration">/ {isYearly ? "Year" : "Month"}</span>
                </p>
                <button 
                  className={`epic-x-button ${currentPlan === plan.planName ? 'epic-x-button-disabled' : ''}`} 
                  onClick={() => handleGetStarted(plan.planName)}
                  disabled={currentPlan === plan.planName}
                >
                  {currentPlan === plan.planName ? 'Current Plan' : 'Get Started Now'}
                </button>
                <h6 className="epic-x-features-title">
                  {index === 0 ? "What you get:" : 
                   `All ${index === 1 ? "free" : index === 2 ? "Growth" : "Professional"} features, plus:`}
                </h6>
                <ul className="epic-x-features">
                  {plan.features.map((feature, i) => (
                    <li
                      key={i}
                      className="epic-x-feature"
                    >
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Pricing Section End */}
      <Footer />
    </div>
  );
};

export default ChatPrice;